export default "__VITE_ASSET__aac03e62__"